import { StoreState } from 'state/rootReducer';

export const getUserInfo = ({ userInfo }: StoreState) => ({
  physicianId: userInfo.userData.physicianId,
  profileId: userInfo.profileId,
  subscriptionId: userInfo.userData.subscriptionId,
  isSubscriber: userInfo.userData.isSubscriber,
  isAdmin: userInfo.userData.isAdmin,
  permissions: userInfo.userData.permissions,
});

export const getSharedInfo = (state: any) => state.shared;
